import { MentorshipDetails } from "@/lib/api/mentorships";
import { UserInfo } from "./user-info";
import { User } from "@/lib/api/user";
import { TeenAccessRecords } from "./teen-access-records";

export function Contact({
  mentorship,
  supervisor,
  adminMode,
}: {
  mentorship: MentorshipDetails;
  supervisor: User | null;
  adminMode: boolean;
}) {
  return (
    <div>
      <UserInfo user={mentorship?.mentee} isLoading={false} />
      <UserInfo user={mentorship?.mentor} isLoading={false} />
      {supervisor && <UserInfo user={supervisor} isLoading={false} />}
      {mentorship?.mentee && adminMode && (
        <TeenAccessRecords menteeId={mentorship?.mentee?.id} />
      )}
    </div>
  );
}
